var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.4883C9.21094 14.4883 9.38672 14.418 9.52734 14.2773C9.66797 14.1367 9.73828 13.9609 9.73828 13.75C9.73828 13.5391 9.66797 13.3633 9.52734 13.2227C9.38672 13.082 9.21094 13.0117 9 13.0117C8.78906 13.0117 8.61328 13.082 8.47266 13.2227C8.33203 13.3633 8.26172 13.5391 8.26172 13.75C8.26172 13.9609 8.33203 14.1367 8.47266 14.2773C8.61328 14.418 8.78906 14.4883 9 14.4883ZM2.98828 4.01172V12.2383H15.0117V4.01172H2.98828ZM15.0117 13.75H18C18 14.1719 17.8477 14.5352 17.543 14.8398C17.2617 15.1211 16.9102 15.2617 16.4883 15.2617H1.51172C1.08984 15.2617 0.726562 15.1211 0.421875 14.8398C0.140625 14.5352 0 14.1719 0 13.75H2.98828C2.58984 13.75 2.23828 13.6094 1.93359 13.3281C1.65234 13.0234 1.51172 12.6602 1.51172 12.2383V4.01172C1.51172 3.58984 1.65234 3.23828 1.93359 2.95703C2.23828 2.65234 2.58984 2.5 2.98828 2.5H15.0117C15.4102 2.5 15.75 2.65234 16.0312 2.95703C16.3359 3.23828 16.4883 3.58984 16.4883 4.01172V12.2383C16.4883 12.6602 16.3359 13.0234 16.0312 13.3281C15.75 13.6094 15.4102 13.75 15.0117 13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu02);
export default __webpack_public_path__ + "static/media/icon_menu_02.0fe64065b023644872bc2036285a2070.svg";
export { ForwardRef as ReactComponent };